import { motion } from "framer-motion";
import { RefreshCw } from "lucide-react";
import { Reveal, MaskLineInView } from "./Reveal";

const REASONS = [
  "Öffnungszeiten ändern sich",
  "Neue Mitarbeiter kommen hinzu",
  "Neue Leistungen werden angeboten",
  "Neue Referenzen entstehen",
  "Bilder werden aktualisiert",
];

const LEVELS = [
  { name: "Basic", label: "Gelegentliche Änderungen", detail: "Bis zu 1 kleiner Änderungsauftrag pro Monat." },
  { name: "Business", label: "Regelmäßige Änderungen", detail: "Bis zu 3 kleinere Änderungsaufträge pro Monat." },
  { name: "Premium", label: "Erweiterter Änderungsservice", detail: "Bis zu 5 kleinere Änderungsaufträge pro Monat." },
];

export default function ChangeService() {
  return (
    <section id="aenderungen" className="relative py-14 lg:py-20 border-t border-white/10 bg-[#0b0806]/70" data-testid="change-service">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-start">
          <div>
            <Reveal className="font-tech text-xs uppercase tracking-[0.25em] text-[#FF3B00] mb-6 flex items-center gap-3">
              <span className="h-px w-10 bg-[#FF3B00]" /> Änderungsservice
            </Reveal>
            <h2 className="font-display text-4xl md:text-6xl leading-[0.98] tracking-tight text-white uppercase mb-6">
              <MaskLineInView>Ihre Website wächst</MaskLineInView>
              <MaskLineInView delay={0.1} className="text-[#FF3B00]">mit Ihrem Unternehmen.</MaskLineInView>
            </h2>
            <Reveal delay={0.15} className="text-neutral-300 text-base leading-relaxed mb-8">
              Unser Service endet nicht mit der Veröffentlichung. Verändert sich etwas in Ihrem
              Unternehmen, übernehmen wir je nach Paket die Aktualisierung direkt für Sie.
            </Reveal>
            <ul className="grid sm:grid-cols-2 gap-3">
              {REASONS.map((r) => (
                <li key={r} className="flex items-center gap-2.5 text-neutral-300 text-sm">
                  <RefreshCw size={15} className="text-[#FF3B00] shrink-0" /> {r}
                </li>
              ))}
            </ul>
          </div>

          <div className="space-y-4">
            {LEVELS.map((l, i) => (
              <motion.div
                key={l.name}
                initial={{ opacity: 0, x: 30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                className="border border-white/10 bg-[#100b07] p-6 flex items-center justify-between gap-4"
                data-testid={`change-level-${l.name.toLowerCase()}`}
              >
                <div>
                  <p className="font-display text-xl text-white">{l.name}</p>
                  <p className="text-[#FF3B00] text-sm mt-1">{l.label}</p>
                </div>
                <p className="text-neutral-500 text-xs text-right max-w-[160px]">{l.detail}</p>
              </motion.div>
            ))}
            <p className="text-neutral-600 text-xs pt-1">
              Nicht genutzte Änderungsaufträge werden nicht auf Folgemonate übertragen. Was als Änderung
              zählt, erklären wir im FAQ.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
